import { Bell, ArrowRight } from "lucide-react";

const DashboardPlatformHealth = ({ performance, bounceStats, pushRegCount, loading, onPushClick }) => {
  if (loading) return <div className="sz-card h-[300px] animate-pulse" />;

  const completionRate = performance?.completion_rate ?? 0;
  const avgRating = performance?.avg_rating ?? 0;
  const hireRate = performance?.hire_rate ?? 0;
  const bounceCount = bounceStats?.bounced_count ?? bounceStats?.total_bounced ?? 0;

  const items = [
    { label: "Completion Rate", value: `${completionRate}%`, pct: completionRate, fg: "#15803D" },
    { label: "Average Rating", value: `${avgRating} / 5`, pct: (avgRating / 5) * 100, fg: "#D97706" },
    { label: "Hire Rate", value: `${hireRate}%`, pct: hireRate, fg: "#2563EB" },
    {
      label: "Email Bounces",
      value: bounceCount,
      pct: Math.min(100, bounceCount),
      fg: bounceCount > 10 ? "#DC2626" : bounceCount > 0 ? "#D97706" : "#15803D",
    },
  ];

  return (
    <section className="sz-card" style={{ padding: "20px 22px" }}>
      <h3 className="text-[15px] font-bold text-[#0C1120]" style={{ fontFamily: "Poppins,sans-serif" }}>
        Platform Health
      </h3>
      <div className="mt-[3px] text-[12px] text-[#8A90A2]">Key operational metrics</div>

      <div className="mt-4 flex flex-col gap-[15px]">
        {items.map((item) => (
          <div key={item.label}>
            <div className="mb-[6px] flex items-center justify-between">
              <span className="text-[12.5px] font-semibold text-[#2B3142]">{item.label}</span>
              <span className="text-[13px] font-bold" style={{ fontFamily: "Poppins,sans-serif", color: item.fg }}>
                {item.value}
              </span>
            </div>
            <div className="h-2 overflow-hidden rounded-full bg-[#F1F3F7]">
              <div
                className="h-full rounded-full transition-all"
                style={{ width: `${Math.max(0, Math.min(100, item.pct))}%`, background: item.fg }}
              />
            </div>
          </div>
        ))}

        {/* Push Registrations CTA */}
        <button
          onClick={onPushClick}
          className="flex items-center justify-between gap-2.5 rounded-xl border border-[#EDE4F4] bg-[#FAF7FC] px-3.5 py-3 text-left transition-colors hover:border-[#78287C]"
        >
          <div className="flex items-center gap-2.5">
            <Bell className="h-[17px] w-[17px] text-[#78287C]" strokeWidth={2} />
            <span className="text-[12.5px] font-semibold text-[#572B7C]">Push Registrations</span>
          </div>
          <span className="flex items-center gap-1 text-[14px] font-bold text-[#78287C]" style={{ fontFamily: "Poppins,sans-serif" }}>
            {pushRegCount} <ArrowRight className="h-3.5 w-3.5" />
          </span>
        </button>
      </div>
    </section>
  );
};

export default DashboardPlatformHealth;
